const priceSelectorV2 = {
  hasShoppingParam: false,
  init: function () {
    const that = this;
    // Manually set isES to true
    window.isES = true;
    const isEs = window.isES;

    this.hasShoppingParam =
      new URLSearchParams(window.location.search).get("shopping") == "1";

    this.preSelectSSOption();

    if (isEs) {
      document.querySelectorAll(".es-dependent").forEach(function (el) {
        el.classList.add("es-dependent-show");
      });
    }

    // PDP Vertical, Horizontal, Vertical with SS Dropdown PDP price tests
    document.querySelectorAll(".pdp-card").forEach(function (card) {
      card.addEventListener("click", function (e) {
        e.stopPropagation();

        const pdpElement = this.closest(".pdp-selector");
        if (!pdpElement) {
          return;
        }
        const isSS = this.classList.contains("pdp-card-single");
        const pdpCardActiveClass = "pdp-active";

        // since this code is shared between vertical horizontal and dropdown. We need to prevent a click on select dropdown from fire multiple times
        if (
          this.classList.contains(pdpCardActiveClass) ||
          e.target.nodeName.toUpperCase() === "SELECT"
        ) {
          return;
        }

        const pdpDetails = pdpElement.querySelector(".pdp-selector-details");
        const wasSSActive = pdpElement
          .querySelector("." + pdpCardActiveClass)
          ?.classList.contains("pdp-card-single");

        pdpElement.querySelectorAll(".pdp-card").forEach(function (el) {
          el.classList.remove(pdpCardActiveClass);
        });

        this.classList.add(pdpCardActiveClass);

        // Animate pdp card details slide up and slide down and display the selected card's details
        if (!isSS && wasSSActive) {
          // toggle from ss to sub
          pdpDetails.querySelector(".pdp-freq-selected").textContent =
            this.dataset.freq;
          pdpDetails.classList.remove("pdp-hide-freq");
        } else if (isSS && !wasSSActive) {
          // toggle from sub to ss
          pdpDetails.classList.add("pdp-hide-freq");
        } else if (!isSS && !wasSSActive) {
          // toggle from sub to sub
          pdpDetails.classList.add("pdp-hide-freq");
          clearTimeout(pdpElement.dataset?.detailToggleTimer);
          pdpElement.dataset.detailToggleTimer = setTimeout(() => {
            pdpDetails.querySelector(".pdp-freq-selected").textContent =
              this.dataset.freq;
            pdpDetails.classList.remove("pdp-hide-freq");
          }, 400);
        }
      });
    });

    document
      .querySelectorAll(".product-selector .js-open-gift-info")
      .forEach(function (el) {
        const allFreqs = [];
        el.closest(".pdp-selector")
          .querySelectorAll(".pdp-card.pdp-sub-card")
          .forEach(function (card) {
            const freq = card.dataset.freq;
            const qty = card.dataset.qty;
            if (freq && qty > 1) {
              allFreqs.push(freq);
            }
          });
        allFreqs.sort((a, b) => a - b);
        const lower = allFreqs.shift();
        const higher = allFreqs.pop();
        const giftInfoModalOverlay = document.querySelector(
          ".gift-info-modal-overlay"
        );
        if (!lower || !higher || !giftInfoModalOverlay) {
          return;
        }
        el.addEventListener("click", function () {
          // const freq = el.closest(".pdp-card.pdp-sub-card").dataset.freq;
          // giftInfoModalOverlay
          //   .querySelectorAll(".month-lower")
          //   .forEach(function (elLower) {
          //     elLower.textContent = lower;
          //   });
          // giftInfoModalOverlay
          //   .querySelectorAll(".month-higher")
          //   .forEach(function (elHigher) {
          //     elHigher.textContent = higher;
          //   });
          // giftInfoModalOverlay
          //   .querySelectorAll(".modal-header")
          //   .forEach(function (modalHeader) {
          //     if (
          //       (modalHeader.classList.contains("modal-header-lower") &&
          //         freq == lower) ||
          //       (modalHeader.classList.contains("modal-header-higher") &&
          //         freq == higher)
          //     ) {
          //       modalHeader.style.display = "block";
          //     } else {
          //       modalHeader.style.display = "none";
          //     }
          //   });
          // giftInfoModalOverlay
          //   .querySelector(".month-toggle .three")
          //   .classList.toggle("selected", freq == lower);
          // giftInfoModalOverlay
          //   .querySelector(".month-toggle .six")
          //   .classList.toggle("selected", freq == higher);
          giftInfoModalOverlay.classList.add("show-modal");
        });
      });

    const setSubscriberUi = (isES) => {
      console.log("setSubscriberUI");
      if (isES) {
        document.querySelector(
          "label.subscription-tab span.max-discount"
        ).innerHTML = "(Choose a Free Gift)";
        const esMessages = document.querySelectorAll(".es-info");
        for (let i = 0; i < esMessages.length; i++) {
          esMessages[i].style.display = "block";
        }

        const esModalTriggers = document.querySelectorAll(
          "[data-trigger-es-modal]," +
            ".es-modal-overlay," +
            ".es-modal-overlay .modal-close svg"
        );
        for (let i = 0; i < esModalTriggers.length; i++) {
          esModalTriggers[i].addEventListener("click", toggleEsModal);
        }
      }
    };

    if (window.igReadyAwaitingDom) {
      this.onIgReady();
    }

    if (!window.isSelectorInitialized) {
      console.log("Starting Intelligems");
      window.isSelectorInitialized = true;
      window.addEventListener("message", function (event) {
        if (event.data !== "scale-ig-ready") {
          return;
        }
        // Intelligems tends to post the same ig-ready message twice in very quick
        // succession of eachother. Wait 50 milliseconds before actually doing anything.
        if (window.igReadyTimeoutId) {
          window.clearTimeout(window.igReadyTimeoutId);
        }
        window.igReadyTimeoutId = window.setTimeout(function () {
          priceSelectorV2.onIgReady();
          priceSelectorV2.triggerAllSSCardSelects();
        }, 50);
      });

      document.addEventListener("DOMContentLoaded", function () {
        priceSelectorV2.init();
      });
    }

    document
      .querySelectorAll(".product-selector .js-add-item-btn")
      .forEach(function (el) {
        el.addEventListener("click", that.addToCartHandler);
      });

    // PDP test2 dropdown listener
    document
      .querySelectorAll(".pdp-card-ss-qty-dropdown select")
      .forEach(function (selectEl) {
        selectEl.addEventListener("change", function () {
          priceSelectorV2.ssCardSelectEvent(this);
          this.closest(".pdp-card-single").dispatchEvent(new Event("click"));
        });
      });
    console.log(
      "About to select default based on which card has the default-active class"
    );
    // trigger click event to setup 3 month sub or SS qty1 if shopping suffixed or in param
    document.querySelectorAll(".pdp-selector").forEach(function (pdpElement) {
      const cardsToActivate =
        pdpElement.querySelector(
          this.hasShoppingParam
            ? ".pdp-card-single"
            : ".pdp-card.default-active"
        ) ?? pdpElement.querySelector(".pdp-card");
      if (cardsToActivate) {
        cardsToActivate.dispatchEvent(new Event("click"));
      }
    });

    // hero selector SS-link click
    document
      .querySelectorAll(".pdp-selector .pdp-card-premium .premium-link a")
      .forEach(function (premiumLink) {
        const variantId =
          premiumLink.closest(".pdp-card-premium")?.dataset.variantId;
        if (!variantId) {
          return;
        }
        premiumLink.addEventListener("click", function (e) {
          priceSelectorV2.addToCart(
            {
              id: variantId,
              quantity: 1,
              properties: priceSelectorV2.getIgPricesForSelector(
                e.currentTarget.closest(".pdp-selector")
              ),
            },
            null,
            premiumLink
              .closest(".pdp-selector")
              .classList.contains("no-checkout-redirect")
          );
        });
      });
  },

  preSelectSSOption: function () {
    document.querySelectorAll(".pdp-selector").forEach((pdpSelector) => {
      const shoppingSelect = pdpSelector.querySelector(
        "#pdp-card-ss-qty-selector"
      );
      shoppingSelect?.setAttribute(
        "is-shopping",
        this.hasShoppingParam ? "true" : "false"
      );
      const variantSelectorShopping = pdpSelector.querySelector(
        ".pdp-card-ss-qty-option"
      );

      if (variantSelectorShopping) {
        variantSelectorShopping.dataset.shoppingParam = this.hasShoppingParam;
        if (this.hasShoppingParam) {
          const firstOption = shoppingSelect.querySelector("option");
          if (firstOption) {
            firstOption.selected = true;
          }
        } else {
          const secondOption = shoppingSelect.querySelector(
            "option:nth-child(2)"
          );
          if (secondOption) {
            secondOption.selected = true;
          }
        }
      }
    });
  },

  /**
   * @param {HTMLDivElement} pdpSelector The `div.pdp-selector` containing the 3
   * `div.pdp-sub-card`s with a `[data-variant-id]`
   * @returns {object} Intelligems' prices for the variants. This is an object
   * for items that have an active price test, the keys follow a format of
   * `_igp_{variant_id}` and the values are the bulk discounted price for the variant
   */
  getIgPricesForSelector: function (pdpSelector) {
    const prices = {};
    pdpSelector
      .querySelectorAll(".pdp-sub-card[data-variant-id]")
      .forEach(function (el) {
        const igPrice = window.igData?.price.getPriceByVariantId(
          el.dataset.variantId
        );
        if (igPrice) {
          prices[`_igp_${el.dataset.variantId}`] = igPrice * 100;
        }
      });
    return prices;
  },

  addToCartHandler: function (e) {
    const pdpSelector = e.currentTarget.closest(".pdp-selector");
    if (!pdpSelector) {
      return;
    }

    const productSelector = pdpSelector.closest(".product-selector");
    if (!productSelector) {
      return;
    }

    const card = pdpSelector.querySelector(".pdp-card.pdp-active");
    if (!card) {
      return;
    }

    const giftModalOverlay = document.querySelector(".gift-modal-overlay");

    const isSS = card.classList.contains("pdp-card-single");
    const qty = isSS
      ? card.querySelector(".pdp-card-ss-qty-dropdown select")?.value
      : card.dataset.qty;
    const cartItem = {
      id: card.dataset.variantId,
      quantity: 1,
      properties: priceSelectorV2.getIgPricesForSelector(pdpSelector),
    };
    if (card.dataset.sellingPlan) {
      cartItem.selling_plan = card.dataset.sellingPlan;
    }
    if (window.isES && !isSS && qty > 1 && giftModalOverlay) {
      giftModalOverlay.querySelector(".modal").dataset.cartItem =
        JSON.stringify(cartItem);
      giftModalOverlay.querySelector(".modal").dataset.noCheckoutRedirect =
        pdpSelector.classList.contains("no-checkout-redirect") ? 1 : 0;
      giftModalOverlay.classList.add("show-modal");
      return false;
    }

    priceSelectorV2.addToCart(
      cartItem,
      null,
      pdpSelector.classList.contains("no-checkout-redirect")
    );
  },

  /**
   * Sets the max % off in the tab headers. Should be run after Intelligems
   * (possibly) edits the base prices.
   */
  setMaxDiscount: function () {
    console.log("setMaxDiscount");
    const productSelectors = document.querySelectorAll(".product-selector");
    var productSelector = null,
      subItems = [],
      ssItems = [],
      subDiscounts = [],
      ssDiscounts = [],
      subMaxDiscount = "",
      ssMaxDiscount = "",
      subTab = null,
      ssTab = null;
    for (let i = 0; i < productSelectors.length; i++) {
      productSelector = productSelectors[i];
      subItems = productSelector.querySelectorAll(
        ".product-selector .pdp-sub-card"
      );
      ssItems = productSelector.querySelectorAll(
        ".product-selector .pdp-card-single"
      );

      subDiscounts = [];
      ssDiscounts = [];
      for (let j = 0; j < subItems.length; j++) {
        subDiscounts.push(parseInt(subItems[j].dataset.discountPercentage));
      }
      for (let j = 0; j < ssItems.length; j++) {
        ssDiscounts.push(parseInt(ssItems[j].dataset.discountPercentage));
      }
      subMaxDiscount = Math.max(...subDiscounts);
      ssMaxDiscount = Math.max(...ssDiscounts);

      subTab = productSelector.querySelector(
        "label.subscription-tab span.max-discount"
      );
      ssTab = productSelector.querySelector(
        "label.straight-sale-tab span.max-discount"
      );

      //subTab.style.visibility = 'visible';

      /*  We don't have tabs on EE
      if (subMaxDiscount > 0 && !window.isES) {
        subTab.querySelector('.max-discount-amount').innerHTML =
          subMaxDiscount;
      }

      if (ssMaxDiscount > 0) {
        ssTab.querySelector('.max-discount-amount').innerHTML = ssMaxDiscount;
        ssTab.style.visibility = 'visible';
      }
      */
    }
  }, // End setMaxDiscount

  /**
   * Callback for when Intelligems runs `window.postMessage("ig-ready");` to
   * indicate that the window.igData object may be used.
   */
  onIgReady: function () {
    console.log("onIgReady");
    document.querySelectorAll(".pdp-selector").forEach(
      /** @param {HTMLDivElement} selectorEl */ function (selectorEl) {
        let qtyOneCard = selectorEl.querySelector(
          '.pdp-sub-card[data-canonical-quantity="1"]'
        );
        // If product is only offered as a 1 time purchase ss
        let qtyTwoCard = selectorEl.querySelector(
          '.pdp-card-single[data-qty="1"]'
        );
        console.log(qtyTwoCard);
        const priceDataset = qtyOneCard ? qtyOneCard : qtyTwoCard;
        if (!priceDataset) {
          return;
        }
        const basePrice =
          window.igData.price.getComparePriceByVariantId(
            priceDataset.dataset.variantId
          ) || priceDataset.dataset.basePrice;
        // Edit the subscription cards
        selectorEl.querySelectorAll(".pdp-sub-card").forEach(
          /** @param {HTMLDivElement} subCard */ function (subCard) {
            const itemBasePrice = basePrice * subCard.dataset.canonicalQuantity;
            subCard.dataset.basePrice = itemBasePrice;
            const itemBulkDiscountedPrice =
              window.igData.price.getPriceByVariantId(
                subCard.dataset.variantId
              ) || subCard.dataset.bulkPrice;
            subCard.dataset.bulkPrice = itemBulkDiscountedPrice;
            let fullyDiscountedPrice =
              itemBulkDiscountedPrice -
              (itemBulkDiscountedPrice *
                subCard.dataset.subDiscountPercentage) /
                100;
            // BFCM Subtract 20% from the final price
            /*
            fullyDiscountedPrice =
              fullyDiscountedPrice - (fullyDiscountedPrice * 20) / 100;
            */
            // BFCM ADD 20% to the save xxxx percentage

            const discountAmount = itemBasePrice - fullyDiscountedPrice;
            const discountPercentage = (discountAmount * 100) / itemBasePrice;
            subCard.dataset.discountPercentage = discountPercentage;

            // BFCM Save percentage
            subCard.querySelector(".js-pdp-sub-card-perc-off").innerText =
              Math.round(discountPercentage);
            // BFCM Save percentage END
            subCard.querySelector(".js-pdp-sub-card-total-off").innerText =
              "$" + (discountAmount.toFixed(2) + "").replace(".00", "");
            const perUnitParts = (
              (
                fullyDiscountedPrice / subCard.dataset.canonicalQuantity
              ).toFixed(2) + ""
            ).split(".");
            // BFCM Price Discount
            const perUnitDollars = Math.trunc(perUnitParts[0]);
            const perUnitCents = perUnitParts[1];
            // BFCM Price Discount End
            subCard.querySelector(".pdp-card-price-dollars span").innerText =
              perUnitDollars;
            subCard.querySelector(".pdp-card-price-cents").innerText =
              perUnitCents;
          }
        );
        // Edit the one time purchase options
        selectorEl.querySelectorAll(".pdp-card-ss-qty-dropdown option").forEach(
          /** @param {HTMLOptionElement} */ function (optionEl, idx) {
            const itemBulkDiscountedPrice =
              window.igData.price.getPriceByVariantId(optionEl.dataset.id) ||
              optionEl.dataset.price;
            let fullyDiscountedPrice = itemBulkDiscountedPrice;
            let OldDiscountedPrice = fullyDiscountedPrice;
            // Intelligems campaigns
            window.igData.campaigns
              .getAll()
              .filter(function (campaign) {
                if (!campaign.discount) {
                  return false;
                }
                if (campaign.discount.testProducts.length === 0) {
                  return true;
                }
                // Filter out hardcoded volume discounts
                if (/(08839d16c6d1|cc1ac2ae59cc)$/.test(campaign.campaignId)) {
                  return false;
                }

                // Only campaigns that include this product should be considered
                for (
                  let k = 0;
                  k < campaign.discount.testProducts.length;
                  k++
                ) {
                  for (
                    let m = 0;
                    m < campaign.discount.testProducts[k].variants.length;
                    m++
                  ) {
                    if (
                      campaign.discount.testProducts[k].variants[m].id ==
                      optionEl.dataset.id
                    ) {
                      return true;
                    }
                  }
                }
                return false;
              })
              .forEach(function (campaign) {
                const applicableTiers = campaign.discount.tiers
                  .filter(function (tier) {
                    // Filter out discount tiers that don't fit for this variant
                    if (tier.isFreeShipping || tier.isGiftWithPurchase) {
                      return false;
                    }
                    switch (campaign.discount.unitType) {
                      case "unit":
                        return (
                          optionEl.value >= tier.minimumUnits &&
                          optionEl.value <= tier.maximumUnits
                        );
                      case "dollar":
                        return (
                          itemBulkDiscountedPrice >= tier.minimumUnits &&
                          itemBulkDiscountedPrice <= tier.maximumUnits
                        );
                      default:
                        console.error(
                          "Unsupported discount.unitType",
                          campaign.discount.unitType
                        );
                        return false;
                    }
                  })
                  .sort(function (tierA, tierB) {
                    // Sort descending by minimum units so that the best applicable tier
                    // is the first element (in case more than one tier applies)
                    return tierB.minimumUnits - tierA.minimumUnits;
                  });
                if (applicableTiers.length === 0) {
                  return;
                }
                switch (campaign.discount.discountType) {
                  case "percentage":
                    fullyDiscountedPrice -=
                      (itemBulkDiscountedPrice *
                        applicableTiers[0].unitDiscount) /
                      100;
                    break;
                  case "dollar":
                    fullyDiscountedPrice -= applicableTiers[0].unitDiscount;
                    break;
                  default:
                    console.error(
                      "Unsupported discount.discountType",
                      campaign.discount.discountType
                    );
                    break;
                }
              });
            if (!optionEl.dataset.priceRendered) {
              if (fullyDiscountedPrice < 0) {
                fullyDiscountedPrice = 0;
              }
              // BFCM Subtract 20% from the final price
              /*
              fullyDiscountedPrice =
                fullyDiscountedPrice - (fullyDiscountedPrice * 20) / 100;
              */
              if (idx == 0) {
                document.querySelector(".premium-link a").innerText =
                  "Buy Once for $" +
                  parseFloat(fullyDiscountedPrice).toFixed(2) +
                  (fullyDiscountedPrice < 45 ? " + $5.95 shipping" : "");
              }

              optionEl.dataset.price = fullyDiscountedPrice;
              discountPercentage =
                100 - (fullyDiscountedPrice / optionEl.dataset.basePrice) * 100;

              optionEl.dataset.discountPercentage =
                discountPercentage.toFixed(0);
              optionEl.dataset.percentText =
                discountPercentage > 0
                  ? "Save " + discountPercentage.toFixed(0) + "%"
                  : "Market Price";
              //console.log(optionEl.dataset);
              const unitPrice = fullyDiscountedPrice / optionEl.value;
              const perDayCost = unitPrice / selectorEl.dataset.supplyDays;
              const unitPriceParts = (unitPrice.toFixed(2) + "").split(".");
              optionEl.dataset.each = unitPrice;
              optionEl.dataset.savingsText =
                "Only $" + perDayCost.toFixed(2) + " per day";
              optionEl.dataset.eachDollars = unitPriceParts[0];
              optionEl.dataset.eachCents = unitPriceParts[1];
              optionEl.setAttribute("data-price-rendered", true);
              priceSelectorV2.ssCardSelectEvent(optionEl.closest("select"));
            }
          }
        );
      }
    );
  }, // End onIgReadyCallback

  addToCart: function (item, giftVariantId, noCheckoutRedirect = false) {
    this.cartDrawer = document.querySelector("cart-drawer");
    const sections = this.cartDrawer
      ? this.cartDrawer.getSectionsToRender().map((section) => section.id)
      : [];

    const cart = {
      items: [item],
      sections: sections,
      sections_url: window.location.pathname,
    };
    if (giftVariantId) {
      cart.items.push({
        id: giftVariantId,
        quantity: 1,
        properties: {
          _igGWP: "1",
        },
      });
    }

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(cart),
    })
      .then((response) => response.json())
      .then((response) => {
        // item is added to cart at this point
        // we can go to checkout or do something else.
        document
          .querySelectorAll(".modal-overlay.show-modal")
          .forEach((modalOverlay) =>
            modalOverlay.classList.remove("show-modal")
          );
        if (this.cartDrawer) {
          this.cartDrawer.renderContents(response);
        } else {
          window.location.href = "/checkout";
        }
      })
      .catch((error) => {
        alert("Item could not be added to cart, please try again.");
        console.error("Err:", error);
      });
  },

  ssCardSelectEvent: function (element) {
    const pdpElement = element.closest(".pdp-selector");
    if (!pdpElement) {
      return;
    }

    // adjust SS data attributes to reflect change
    const ssCard = pdpElement.querySelector(".pdp-card-single");
    const selected = element.options[element.selectedIndex];
    ssCard.dataset.qty = element.value;
    ssCard.dataset.bulkPrice = selected.dataset.price;
    ssCard.dataset.basePrice = selected.dataset.basePrice;
    ssCard.dataset.variantId = selected.dataset.id;
    ssCard.dataset.discountPercentage = selected.dataset.discountPercentage;
    ssCard.querySelector(".pdp-card-price-dollars").textContent =
      "$" + selected.dataset.eachDollars;
    ssCard.querySelector(".pdp-card-price-cents").textContent =
      selected.dataset.eachCents;
    ssCard.querySelector(".pdp-card-saving-amount").textContent =
      selected.dataset.savingsText;
    ssCard.querySelector(".pdp-card-saving-percent span").textContent =
      selected.dataset.percentText;
  },

  triggerAllSSCardSelects: function () {
    const that = this;
    document
      .querySelectorAll(".pdp-card-ss-qty-dropdown select")
      .forEach(function (el) {
        priceSelectorV2.ssCardSelectEvent(el);
        const ssCard = el.closest(".pdp-card-single");
        if (that.hasShoppingParam) {
          const oldCard = el
            .closest(".pdp-selector")
            .querySelector(".pdp-active");
          oldCard.classList.remove("pdp-active", "default-active");
          ssCard.classList.add("pdp-active", "default-active");
        }
        if (ssCard.classList.contains("pdp-active")) {
          ssCard.dispatchEvent(new Event("click"));
        }
      });
  },

  setPremiumSelector: function (showPremium) {
    document.querySelectorAll(".premium-dependent").forEach(function (el) {
      el.classList.toggle("premium-dependent-show", showPremium);
    });
    document.querySelectorAll(".not-premium-dependent").forEach(function (el) {
      el.classList.toggle("not-premium-dependent-show", !showPremium);
    });
  },
};

document.addEventListener("DOMContentLoaded", function () {
  priceSelectorV2.init();
});

window.addEventListener("pageshow", function () {
  priceSelectorV2.triggerAllSSCardSelects();
});

window.priceSelectorV2 = priceSelectorV2;
